import React from "react";

import {
  startupDilligenceImage,
  corporateVentureImage,
  financeStrategyImage,
  fundRaisingImage,
  legalAndComplianceImage,
  marketStrategyImage,
  marketingAndSalesImage,
  portfolioSupportImage,
  productEngineeringImage,
  reportOnAnythingImage,
  technologyAndRndImage,
} from "./_assets";

import jsCookie from "js-cookie";

import startupDilligenceIcon from "./_assets/AgentLanding-Icons/CompanyDilligance.svg";
import corporateVentureIcon from "./_assets/AgentLanding-Icons/VentureCapital.svg";
import financeAndStrategyIcon from "./_assets/AgentLanding-Icons/FinanceStrategy.svg";
import fundRaisingIcon from "./_assets/AgentLanding-Icons/fundraise.svg";
import legalAndComplianceIcon from "./_assets/AgentLanding-Icons/LegalSupport.svg";
import marketStrategyIcon from "./_assets/AgentLanding-Icons/MarketStrategy.svg";
import marketingAndSalesIcon from "./_assets/AgentLanding-Icons/MarketingSales.svg";
import portfolioSupportIcon from "./_assets/AgentLanding-Icons/port.svg";
import productEngineeringIcon from "./_assets/AgentLanding-Icons/ProductEngineering.svg";
import reportOnAnythingIcon from "./_assets/AgentLanding-Icons/ReportAnything.svg";
import technologyAndRndIcon from "./_assets/AgentLanding-Icons/TechnologyR-D.svg";
import MrAgent from "./_assets/AgentLanding-Icons/mrpreview.png"
import EmailAgent from "./_assets/AgentLanding-Icons/emailpreview.png"
import QuantAgent from "./_assets/AgentLanding-Icons/quantitative_research (1).svg"
import QualAgent from "./_assets/AgentLanding-Icons/reliability.svg"

// quantitative_research (1).svg

import AgentCard from "./_components/AgentCard";
import AgentHead from "../AgentHead";
import StartupModal from "./startup-modal";
import carbonMarkerIcon from "./_assets/AgentLanding-Icons/Carbon Market Intelligence Agent.svg";
import commercializationIcon from "./_assets/AgentLanding-Icons/Commercialization Strategy Agent.svg";
import emergingMarketIcon from "./_assets/AgentLanding-Icons/Emerging Market Opportunity Agent.svg";
import esgTracker from "./_assets/AgentLanding-Icons/ESG Compliance Tracker Agent.svg";
import financePortfolio from "./_assets/AgentLanding-Icons/Financial Portfolio Optimization Agent.svg";
import ftoIcon from "./_assets/AgentLanding-Icons/FTO Agent.svg";
import greenInnovation from "./_assets/AgentLanding-Icons/Green Innovation Opportunity Agent.svg";
import inventionDiligence from "./_assets/AgentLanding-Icons/Invention Diligence Agent.svg";
import licensingOpportunity from "./_assets/AgentLanding-Icons/Licensing Opportunity Agent.svg";
import maopportunity from "./_assets/AgentLanding-Icons/M&A Opportunity Mapping Agent.svg";
import operationalEfficiency from "./_assets/AgentLanding-Icons/Operational Efficiency Diligence Agent.svg";
import patentLandacape from "./_assets/AgentLanding-Icons/Patent Landscape Agent.svg";
import patentLicensing from "./_assets/AgentLanding-Icons/Patent Licensing Agent.svg";
import paymentFraud from "./_assets/AgentLanding-Icons/Payment Fraud Monitoring Agent.svg";
import priorArt from "./_assets/AgentLanding-Icons/Prior Art Agent.svg";
import prosecutionHistory from "./_assets/AgentLanding-Icons/Prosecution History Agent.svg";
import nimbusMarketing from "./_assets/AgentLanding-Icons/heroicons-outline_speakerphone.svg";
import regulatoryImpact from "./_assets/AgentLanding-Icons/Regulatory Impact Forecasting Agent.svg";
import riskHorizon from "./_assets/AgentLanding-Icons/Risk Horizon Mapping Agent.svg";
import startupSpinout from "./_assets/AgentLanding-Icons/Startup Spinout Support Agent.svg";
import sustainability from "./_assets/AgentLanding-Icons/Sustainability Risk Assessment Agent.svg";
import technologyReadiness from "./_assets/AgentLanding-Icons/Technology Readiness and Adoption Agent.svg";
import thirdPartyRisk from "./_assets/AgentLanding-Icons/Third-Party Risk Monitoring Agent.svg";
import transactionalRisk from "./_assets/AgentLanding-Icons/Transactional Risk Pattern Agent.svg";
import vendorPartner from "./_assets/AgentLanding-Icons/Vendor and Partner Risk Assessment Agent.svg";
import vendorRisk from "./_assets/AgentLanding-Icons/Vendor Risk Mapping Agent.svg";
import customer360icon from "./_assets/AgentLanding-Icons/Customer360.svg";
import investmentDiligence from "./_assets/AgentLanding-Icons/Investment Dilligence.svg";
import whitepaperLogo from "../../../../assets/images/Whitepaper agent.svg"
import ConnectorValidate from "src/components/connectors/ConnectorValidate";
import ConnectorSetup from "src/components/connectors/ConnectorSetup";

// 


// Custom SVG Icons (replace these with your own SVGs)

export const agents = [
  {
    agentName: "Startup Diligence Agent",
    title: "Company Diligence Agent",
    description: "See the signals others miss — before they become headlines.",
    icon: startupDilligenceIcon,
    bgClass: "from-pink-200 to-red-100",
    className: "",
    backgroundImage: startupDilligenceImage,
    agentLink: "company-diligence-agent",
    section_name: "investors",
    hoverTitle: "Uncover the full picture.",
    hoverDesc:
      "Analyze financials, market position, risks, and team dynamics—all in one report. Make informed decisions with confidence and speed.",
  },
  {
    agentName: "Fundraising Strategy Agent",
    title: "Fundraising Strategy Agent",
    description: "Close your next round with a strategy that sells itself.",
    icon: fundRaisingIcon,
    bgClass: "from-blue-200 to-blue-100",
    className: "",
    backgroundImage: fundRaisingImage,
    agentLink: "fundraising-strategy-agent",
    section_name: "investors",
    hoverTitle: "Craft a winning pitch with insights that matter.",
    hoverDesc:
      "From investor targeting to financial storytelling, get data-backed recommendations to sharpen your fundraising approach and close rounds faster—with less guesswork, more strategy. ",
  },
  {
    agentName: "Report on Anything Agent",
    title: "Report on Anything Agent",
    description: "Get answers to any question — no team, no wait time.",
    icon: reportOnAnythingIcon,
    bgClass: "from-purple-200 to-pink-100",
    className: "",
    backgroundImage: reportOnAnythingImage,
    agentLink: "report-on-anything-agent",
    section_name: "investors",
    disabled: true,
    hoverTitle: "Need something unique? Just ask.",
    hoverDesc:
      "From niche analysis to ad-hoc reports, this agent adapts to your needs—curating insights from scattered data into sharp, executive-ready outputs. ",
  },
  {
    agentName: "Market Strategy Agent",
    title: "Market Strategy Agent",
    description: "Turn trends into traction before the market catches on.",
    icon: marketStrategyIcon,
    bgClass: "from-teal-200 to-blue-100",
    className: "",
    backgroundImage: marketStrategyImage,
    agentLink: "market-strategy-agent",
    section_name: "enterprises",
    hoverTitle: "Turn trends into traction.",
    hoverDesc:
      "Identify emerging market shifts early, backed by real-time data. Get strategic recommendations before competitors even realize what's coming.",
  },
  {
    agentName: "Portfolio Support Agent",
    title: "Portfolio Support Agent",
    description: "Grow your portfolio without growing your headache",
    icon: portfolioSupportIcon,
    bgClass: "from-pink-200 to-purple-100",
    className: "",
    backgroundImage: portfolioSupportImage,
    agentLink: "portfolio-support-agent",
    section_name: "enterprises",
    hoverTitle: "Empower your portfolio companies with more than capital.",
    hoverDesc:
      "Deliver tailored insights on growth strategy, hiring, market shifts, and competitive moves—based on real-time signals. Help founders navigate uncertainty with data that drives execution.",
  },
  {
    agentName: "Technology & R&D Agent",
    title: "Technology & R&D Agent",
    description: "Stay three steps ahead of what’s coming next.",
    icon: technologyAndRndIcon,
    bgClass: "from-yellow-200 to-green-100",
    className: "",
    backgroundImage: technologyAndRndImage,
    agentLink: "technology-agent",
    section_name: "enterprises",
    hoverTitle: "Spot emerging technologies before they go mainstream.",
    hoverDesc:
      "Evaluate partnerships, R&D focus, and innovation risks with data that supports long-term planning.",
  },
  {
    agentName: "Product & Engineering Agent",
    title: "Product & Engineering Agent",
    description: "Build what the market’s already waiting for.",
    icon: productEngineeringIcon,
    bgClass: "from-red-200 to-pink-100",
    className: "",
    backgroundImage: productEngineeringImage,
    agentLink: "product-engineering-agent",
    section_name: "enterprises",
    hoverTitle: "Bridge product vision and tech execution.",
    hoverDesc: "Get actionable insights on roadmap, architecture, and innovation gaps—fast.",
  },
  {
    agentName: "Corporate Venture Capital Agent",
    title: "Corporate Venture Capital Agent",
    description: "Find your next unicorn — and ride it all the way to ROI",
    icon: corporateVentureIcon,
    bgClass: "from-blue-200 to-purple-100",
    className: "",
    backgroundImage: corporateVentureImage,
    agentLink: "corporate-venture-capital-agent",
    section_name: "investors",
    hoverTitle: "dentify the right startup bets with precision.",
    hoverDesc:
      "Evaluate tech trends, team potential, and strategic fit to align your investments with long-term corporate goals.",
  },
  {
    agentName: "Finance & Strategy Agent",
    title: "Finance & Strategy Agent",
    description: "Make every business move a calculated win.",
    icon: financeAndStrategyIcon,
    bgClass: "from-pink-200 to-red-100",
    className: "",
    backgroundImage: financeStrategyImage,
    agentLink: "finance-strategy-agent",
    section_name: "enterprises",
    hoverTitle: "See beyond the balance sheet.",
    hoverDesc:
      "From unit economics to M&A scenarios, this agent brings clarity to complex financial strategies. Identify risks, optimize cost structures, and model decisions backed by current market and internal data.",
  },
  {
    agentName: "Marketing & Sales Agent",
    title: "Marketing & Sales Agent",
    description: "Turn campaigns into conversions — and headlines into revenue.",
    icon: marketingAndSalesIcon,
    bgClass: "from-purple-200 to-blue-100",
    className: "",
    backgroundImage: marketingAndSalesImage,
    agentLink: "marketing-sales-agent",
    section_name: "enterprises",
    hoverTitle: "Refine your go-to-market with precision.",
    hoverDesc:
      "Discover customer pain points, optimize messaging, and spot revenue opportunities across segments—fueled by real-time customer and competitor signals.",
  },
  {
    agentName: "Legal & Compliance Agent",
    title: "Legal & Compliance Agent",
    description: "Navigate complexity with confidence — and zero surprises.",
    icon: legalAndComplianceIcon,
    bgClass: "from-yellow-200 to-orange-100",
    className: "",
    backgroundImage: legalAndComplianceImage,
    agentLink: "legal-compliance-agent",
    section_name: "enterprises",
    hoverTitle: "Stay ahead of regulatory changes and legal risks.",
    hoverDesc:
      "From contract review to global compliance insights, get comprehensive support on complex legal challenges. Minimize exposure and stay audit-ready—with less manual effort, more peace of mind.",
  },
  {
    agentName: "Prior Art Agent",
    title: "Prior Art Agent",
    description: "Protect your idea before it turns up in someone else’s patent.",
    icon: priorArt,
    bgClass: "from-purple-200 to-blue-100",
    className: "",
    backgroundImage: marketingAndSalesImage,
    agentLink: "prior-art-agent",
    hoverTitle: "Don’t miss what’s already out there",
    hoverDesc:
      "This agent searches deep across global patent databases, publications, and prior filings to help you assess novelty fast—and avoid costly rejections or disputes",
    // section_name: "ip_experts",
    disabled: true,
  },
  {
    agentName: "FTO Agent",
    title: "FTO Agent",
    description: "Launch with confidence — no red tape, no regrets.",
    icon: ftoIcon,
    bgClass: "from-yellow-200 to-orange-100",
    className: "",
    backgroundImage: financeStrategyImage,
    agentLink: "fto-agent",

    // section_name: "ip_experts",
    disabled: true,
    hoverTitle: "Launch with confidence.",
    hoverDesc:
      "This agent scans existing patents to uncover infringement risks early, ensuring your products stay compliant in every target market. Save time, reduce legal exposure, and build IP with a clear runway.",
  },
  {
    agentName: "Patent Licensing Agent",
    title: "Patent Licensing Agent",
    description: "Turn unused patents into untapped revenue.",
    icon: patentLicensing,
    bgClass: "from-yellow-200 to-orange-100",
    className: "",
    backgroundImage: legalAndComplianceImage,
    agentLink: "patent-licensing-agent",
    hoverTitle: "Find your best monetization paths",
    hoverDesc:
      "Discover licensing opportunities, negotiate with data in hand, and benchmark deals to ensure your IP delivers maximum value",
    // section_name: "ip_experts",
    disabled: true,
  },
  {
    agentName: "Patent Landscape Agent",
    title: "Patent Landscape Agent",
    description: "See the full IP battlefield — and your best path through it.",
    icon: patentLandacape,
    bgClass: "from-yellow-200 to-orange-100",
    className: "",
    backgroundImage: productEngineeringImage,
    agentLink: "patent-landscape-agent",
    // section_name: "ip_experts",
    disabled: true,
    hoverTitle: "Visualize the IP terrain.",
    hoverDesc:
      "Track competitors, tech trends, and whitespace opportunities in one view—backed by intelligent mapping of global patents.",
  },
  {
    agentName: "Prosecution History Agent",
    title: "Prosecution History Agent",
    description: "Learn from every claim, correction, and curveball — before you file.",
    icon: prosecutionHistory,
    bgClass: "from-yellow-200 to-orange-100",
    className: "",
    backgroundImage: startupDilligenceImage,
    agentLink: "prosecution-history-agent",
    // section_name: "ip_experts",
    disabled: true,
    hoverTitle: "Understand how patents evolved.",
    hoverDesc:
      "Dive into office actions, amendments, and rejections to uncover legal strategies—and use them to your advantage in current or future filings.",
  },
  {
    agentName: "Risk Horizon Mapping Agent",
    title: "Risk Horizon Mapping Agent",
    description: "Analyze future risks across business landscapes for strategic planning.",
    icon: riskHorizon,
    bgClass: "from-blue-100 to-blue-300",
    className: "",
    disabled: true,
    backgroundImage: startupDilligenceImage,
    agentLink: "risk-horizon-mapping-agent",
    hoverTitle: "Map tomorrow’s threats today.",
    hoverDesc: "Identify and assess long-term risks to stay ahead in volatile markets.",
  },
  {
    agentName: "Financial Portfolio Optimization Agent",
    title: "Financial Portfolio Optimization Agent",
    description: "Maximize returns and minimize risks across investment portfolios.",
    icon: financePortfolio,
    bgClass: "from-green-100 to-green-300",
    className: "",
    disabled: true,
    backgroundImage: fundRaisingImage,
    agentLink: "financial-portfolio-optimization-agent",
    hoverTitle: "Smarter portfolios. Higher returns.",
    hoverDesc: "Balance assets dynamically with real-time financial intelligence.",
  },
  {
    agentName: "Regulatory Impact Forecasting Agent",
    title: "Regulatory Impact Forecasting Agent",
    description: "Predict regulatory changes and assess business impact.",
    icon: regulatoryImpact,
    disabled: true,
    bgClass: "from-red-100 to-pink-200",
    className: "",
    backgroundImage: reportOnAnythingImage,
    agentLink: "regulatory-impact-forecasting-agent",
    hoverTitle: "Stay compliant ahead of the curve.",
    hoverDesc: "Understand how future laws could affect your operations.",
  },
  {
    agentName: "Emerging Market Opportunity Agent",
    title: "Emerging Market Opportunity Agent",
    description: "Spot high-growth markets and expansion opportunities.",
    icon: emergingMarketIcon,
    disabled: true,
    bgClass: "from-yellow-100 to-yellow-300",
    className: "",
    backgroundImage: marketStrategyImage,
    agentLink: "emerging-market-opportunity-agent",
    hoverTitle: "Capture new growth zones.",
    hoverDesc: "Explore untapped markets with strategic insights.",
  },
  {
    agentName: "Vendor and Partner Risk Assessment Agent",
    title: "Vendor and Partner Risk Assessment Agent",
    description: "Evaluate third-party risks before engagement.",
    icon: vendorPartner,
    disabled: true,
    bgClass: "from-purple-100 to-purple-300",
    className: "",
    backgroundImage: portfolioSupportImage,
    agentLink: "vendor-and-partner-risk-assessment-agent",
    hoverTitle: "Trust who you work with.",
    hoverDesc: "Screen vendors and partners for operational and compliance risks.",
  },
  {
    agentName: "M&A Opportunity Mapping Agent",
    title: "M&A Opportunity Mapping Agent",
    description: "Identify strategic acquisition and merger opportunities.",
    icon: maopportunity,
    disabled: true,
    bgClass: "from-teal-100 to-cyan-200",
    className: "",
    backgroundImage: technologyAndRndImage,
    agentLink: "ma-opportunity-mapping-agent",
    hoverTitle: "Target high-impact deals.",
    hoverDesc: "Map the landscape for optimal M&A opportunities.",
  },
  {
    agentName: "Payment Fraud Monitoring Agent",
    title: "Payment Fraud Monitoring Agent",
    description: "Detect and prevent payment-related fraud activities.",
    icon: paymentFraud,
    disabled: true,
    bgClass: "from-orange-100 to-red-200",
    className: "",
    backgroundImage: productEngineeringImage,
    agentLink: "payment-fraud-monitoring-agent",
    hoverTitle: "Shield transactions in real time.",
    hoverDesc: "Monitor payment systems for fraud patterns and anomalies.",
  },
  {
    agentName: "Transactional Risk Pattern Agent",
    title: "Transactional Risk Pattern Agent",
    description: "Analyze transaction trends to uncover potential risks.",
    icon: transactionalRisk,
    disabled: true,
    bgClass: "from-indigo-100 to-indigo-300",
    className: "",
    backgroundImage: corporateVentureImage,
    agentLink: "transactional-risk-pattern-agent",
    hoverTitle: "Uncover hidden financial risks.",
    hoverDesc: "Reveal subtle transactional anomalies with AI-driven analysis.",
  },
  {
    agentName: "Invention Diligence Agent",
    title: "Invention Diligence Agent",
    description: "Evaluate invention viability and IP potential.",
    icon: inventionDiligence,
    disabled: true,
    bgClass: "from-lime-100 to-green-200",
    className: "",
    backgroundImage: financeStrategyImage,
    agentLink: "invention-diligence-agent",
    hoverTitle: "Invent with confidence.",
    hoverDesc: "Assess novelty, utility, and risks before you file.",
  },
  {
    agentName: "Commercialization Strategy Agent",
    title: "Commercialization Strategy Agent",
    description: "Develop go-to-market strategies for innovations.",
    icon: commercializationIcon,
    disabled: true,
    bgClass: "from-pink-100 to-pink-300",
    className: "",
    backgroundImage: marketingAndSalesImage,
    agentLink: "commercialization-strategy-agent",
    hoverTitle: "From lab to market.",
    hoverDesc: "Craft effective plans to turn ideas into revenue.",
  },
  {
    agentName: "Licensing Opportunity Agent",
    title: "Licensing Opportunity Agent",
    description: "Identify potential licensing paths for your assets.",
    icon: licensingOpportunity,
    disabled: true,
    bgClass: "from-yellow-100 to-lime-200",
    className: "",
    backgroundImage: legalAndComplianceImage,
    agentLink: "licensing-opportunity-agent",
    hoverTitle: "License smarter.",
    hoverDesc: "Find high-value opportunities to license your technology.",
  },
  {
    agentName: "Startup Spinout Support Agent",
    title: "Startup Spinout Support Agent",
    description: "Support IP-based startup formation and strategy.",
    icon: startupSpinout,
    disabled: true,
    bgClass: "from-blue-100 to-blue-200",
    className: "",
    backgroundImage: marketingAndSalesImage,
    agentLink: "startup-spinout-support-agent",
    hoverTitle: "Empower entrepreneurship.",
    hoverDesc: "Help innovations find a path to startup success.",
  },
  {
    agentName: "Technology Readiness and Adoption Agent",
    title: "Technology Readiness and Adoption Agent",
    description: "Assess and accelerate technology adoption readiness.",
    icon: technologyReadiness,
    disabled: true,
    bgClass: "from-gray-100 to-gray-300",
    className: "",
    backgroundImage: financeStrategyImage,
    agentLink: "technology-readiness-and-adoption-agent",
    hoverTitle: "Ready for market?",
    hoverDesc: "Evaluate tech maturity and adoption potential.",
  },
  {
    agentName: "ESG Compliance Tracker Agent",
    title: "ESG Compliance Tracker Agent",
    description: "Track environmental, social, and governance compliance.",
    icon: esgTracker,
    disabled: true,
    bgClass: "from-green-100 to-emerald-200",
    className: "",
    backgroundImage: legalAndComplianceImage,
    agentLink: "esg-compliance-tracker-agent",
    hoverTitle: "Stay ESG-aligned.",
    hoverDesc: "Ensure your practices meet sustainability standards.",
  },
  {
    agentName: "Sustainability Risk Assessment Agent",
    title: "Sustainability Risk Assessment Agent",
    description: "Evaluate sustainability risks across operations.",
    icon: sustainability,
    disabled: true,
    bgClass: "from-teal-100 to-green-200",
    className: "",
    backgroundImage: productEngineeringImage,
    agentLink: "sustainability-risk-assessment-agent",
    hoverTitle: "Measure your footprint.",
    hoverDesc: "Identify environmental risks impacting your business.",
  },
  {
    agentName: "Green Innovation Opportunity Agent",
    title: "Green Innovation Opportunity Agent",
    description: "Find innovation paths aligned with green priorities.",
    icon: greenInnovation,
    disabled: true,
    bgClass: "from-emerald-100 to-emerald-300",
    className: "",
    backgroundImage: startupDilligenceImage,
    agentLink: "green-innovation-opportunity-agent",
    hoverTitle: "Innovate sustainably.",
    hoverDesc: "Drive growth with eco-conscious innovation.",
  },
  {
    agentName: "Carbon Market Intelligence Agent",
    title: "Carbon Market Intelligence Agent",
    description: "Gain insights into carbon markets and credits.",
    icon: carbonMarkerIcon,
    disabled: true,
    bgClass: "from-gray-100 to-green-100",
    className: "",
    backgroundImage: fundRaisingImage,
    agentLink: "carbon-market-intelligence-agent",
    hoverTitle: "Navigate carbon economics.",
    hoverDesc: "Track carbon pricing, offsets, and regulations.",
  },
  {
    agentName: "Vendor Risk Mapping Agent",
    title: "Vendor Risk Mapping Agent",
    description: "Visualize and assess vendor risks across the supply chain.",
    icon: vendorRisk,
    disabled: true,
    bgClass: "from-purple-100 to-purple-200",
    className: "",
    backgroundImage: reportOnAnythingImage,
    agentLink: "vendor-risk-mapping-agent",
    hoverTitle: "Visualize supplier threats.",
    hoverDesc: "Map supply chain vulnerabilities proactively.",
  },
  {
    agentName: "Operational Efficiency Diligence Agent",
    title: "Operational Efficiency Diligence Agent",
    description: "Identify and improve operational inefficiencies.",
    icon: operationalEfficiency,
    disabled: true,
    bgClass: "from-sky-100 to-sky-300",
    className: "",
    backgroundImage: marketStrategyImage,
    agentLink: "operational-efficiency-diligence-agent",
    hoverTitle: "Streamline operations.",
    hoverDesc: "Evaluate workflows for maximum productivity.",
  },
  {
    agentName: "Third-Party Risk Monitoring Agent",
    title: "Third-Party Risk Monitoring Agent",
    description: "Continuously monitor risks posed by third-party entities.",
    icon: thirdPartyRisk,
    disabled: true,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: portfolioSupportImage,
    agentLink: "third-party-risk-monitoring-agent",
    hoverTitle: "Monitor outsourced risks.",
    hoverDesc: "Stay alert to compliance and performance issues in third parties.",
  },
  {
    agentName: "Customer 360 Agent",
    title: "Customer 360 Agent",
    description: "Customer 360 Agent",
    icon: customer360icon,
    disabled: true,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: marketingAndSalesImage,
    agentLink: "customer-360-agent",
    hoverTitle: "Gain a 360° customer view.",
    hoverDesc: "Unify customer data to enhance insights, personalization, and decision-making.",
  },
  {
    agentName: "Investment Diligence Agent",
    title: "Investment Diligence Agent",
    description: "Investment Diligence Agent",
    icon: investmentDiligence,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: startupDilligenceImage,
    agentLink: "investment-diligence-agent",
    hoverTitle: "Make informed investment decisions.",
    hoverDesc: "Analyze market trends, financial health, and competitive landscape to identify high-potential investments.",
  },
  {
    agentName: "Marketing Agent",
    title: "Marketing Campaign Monitoring Agent",
    description: "Start Campaign Intake",
    icon: nimbusMarketing,
    disabled: true,
    bgClass: "from-sky-100 to-sky-300",
    className: "",
    backgroundImage: marketStrategyImage,
    agentLink: "marketing-agent",
    hoverTitle: "Plan, launch, and optimize campaigns with confidence.",
    hoverDesc: "This agent helps you define goals, allocate budgets, and monitor performance across channels. It delivers daily reports, real-time alerts, and actionable recommendations so you can maximize ROI and scale successful campaigns.",
  },
  {
    agentName: "MR Insights Agent",
    title: "MR Insights Agent",
    description: "MR Insights Agent",
    icon: MrAgent,
    disabled: true,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: marketingAndSalesImage,
    agentLink: "mr-insights-agent",
    hoverTitle: "Gain insights into MR strategies.",
    hoverDesc: "Unify data to enhance insights, personalization, and decision-making.",
  },
  {
    agentName: "Email Automation Agent",
    title: "Email Automation Agent",
    description: "Email Automaton Agent",
    icon: EmailAgent,
    disabled: true,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: marketingAndSalesImage,
    agentLink: "email-automation-agent",
    hoverTitle: "Create and manage emails effectively.",
    hoverDesc: "Streamline content creation, audience segmentation, and performance tracking for impactful emails.",
  },
  {
    agentName: "Qualitative Agent - V2",
    title: "Qualitative Agent - V2",
    description: "Qualitative Agent - V2",
    icon: QualAgent,
    disabled: true,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: reportOnAnythingImage,
    agentLink: "qualitative-agent-v2",
    hoverTitle: "Quantitative Insights Agent.",
    hoverDesc: "The Quantitative Insights Agent converts survey data into a complete, insight-driven PowerPoint deck.",
  },
  {
    agentName: "Qualitative Agent - V3",
    title: "Qualitative Agent - V3",
    description: "Qualitative Agent - V3",
    icon: QualAgent,
    disabled: true,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: reportOnAnythingImage,
    agentLink: "qualitative-agent-v3",
    hoverTitle: "Quantitative Insights Agent.",
    hoverDesc: "The Quantitative Insights Agent converts survey data into a complete, insight-driven PowerPoint deck.",
  },
  {
    agentName: "Quantitative Agent",
    title: "Quantitative Agent",
    description: "Quantitative Agent",
    icon: QuantAgent,
    disabled: true,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: marketStrategyImage,
    agentLink: "quantitative-agent",
    hoverTitle: "Quantitative Insights Agent.",
    hoverDesc: "The Quantitative Insights Agent converts survey data into a complete, insight-driven PowerPoint deck.",
  },
  {
    agentName: "Report Anything Agent",
    title: "Report Anything Agent",
    description: "Report Anything Agent",
    icon: QuantAgent,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: reportOnAnythingImage,
    agentLink: "report-anything-agent",
    hoverTitle: "Report Anything Agent.",
    hoverDesc: "The Report Anything Agent converts survey data into a complete, insight-driven PowerPoint deck.",
  },
  {
    agentName: "Whitepaper Generation Agent",
    title: "Whitepaper Generation Agent",
    description: "Whitepaper Generation Agent",
    icon: whitepaperLogo,
    disabled: true,
    bgClass: "from-rose-100 to-red-100",
    className: "",
    backgroundImage: startupDilligenceImage,
    agentLink: "whitepaper-generation-agent",
    hoverTitle: "Whitepaper Generation Agent.",
    hoverDesc: "The Whitepaper Generation Agent converts survey data into a complete, insight-driven PowerPoint deck.",
  },
];

export default function AgentsGrid() {
  const accessToken = jsCookie.get("pn_refresh");

  return (

    <div>
      {accessToken ? <StartupModal /> : null}
      <div
        className={`lg:px-4 lg:pt-2 lg:pb-12 ${!accessToken ? "w-full md:w-3/4 lg:w-3/4 xl:w-3/5 mx-auto" : ""
          }`}
      >
        <AgentHead agentName="" />
        <h1 className="text-4xl font-bold mb-4">Our Suite of AI Agents</h1>
        <p className="text-lg mb-2">
          Explore our AI agents, each tailored to assist with specific tasks.
        </p>
        <p className="text-lg mb-8">
          <span className="text-orange-500 font-medium">Select</span> the one that best suits your
          needs to get started!
        </p>

        <div className="max-w-[1500px]">
          <h2 className="text-4xl font-bold mb-4">Investors</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[0]} />
            </div>
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[1]} />
            </div>
            <div className="md:col-span-7 lg:col-span-7">
              <AgentCard agent={agents[4]} />
            </div>
            <div className="md:col-span-5 lg:col-span-5">
              <AgentCard agent={agents[7]} />
            </div>
          </div>

          <h2 className="text-4xl font-bold mb-4">Enterprises</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-5 lg:col-span-5">
              <AgentCard agent={agents[3]} />
            </div>
            <div className="md:col-span-7 lg:col-span-7">
              <AgentCard agent={agents[6]} />
            </div>
            <div className="md:col-span-7 lg:col-span-7">
              <AgentCard agent={agents[9]} />
            </div>
            <div className="md:col-span-7 lg:col-span-5">
              <AgentCard agent={agents[5]} />
            </div>
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[8]} />
            </div>
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[10]} />
            </div>
            {/* <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[2]} />
            </div> */}
          </div>

          {/* <h2 className="text-4xl font-bold mb-4">IP Experts</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[11]} />
            </div>
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[12]} />
            </div>
            <div className="md:col-span-7 lg:col-span-7">
              <AgentCard agent={agents[13]} />
            </div>
            <div className="md:col-span-5 lg:col-span-5">
              <AgentCard agent={agents[14]} />
            </div>
            <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[15]} />
            </div>
          </div> */}

          {/* BFSI Agents */}

          {/* <h2 className="text-4xl font-bold mb-4">
            Banking, Financial Services, and Insurance(BFSI)
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-5 lg:col-span-5">
              <AgentCard agent={agents[16]} />
            </div>
            <div className="md:col-span-7 lg:col-span-7">
              <AgentCard agent={agents[17]} />
            </div>
            <div className="md:col-span-7 lg:col-span-7">
              <AgentCard agent={agents[18]} />
            </div>
            <div className="md:col-span-7 lg:col-span-5">
              <AgentCard agent={agents[19]} />
            </div>
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[20]} />
            </div>
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[21]} />
            </div>
            <div className="md:col-span-6 lg:col-span-5">
              <AgentCard agent={agents[22]} />
            </div>
            <div className="md:col-span-6 lg:col-span-7">
              <AgentCard agent={agents[23]} />
            </div>
          </div> */}
          {/* <h2 className="text-4xl font-bold mb-4">TTO/Innovation Labs</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-6 lg:col-span-7">
              <AgentCard agent={agents[24]} />
            </div>
            <div className="md:col-span-6 lg:col-span-5">
              <AgentCard agent={agents[25]} />
            </div>
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[26]} />
            </div>
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[27]} />
            </div>
            <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[28]} />
            </div>
          </div> */}
          {/* <h2 className="text-4xl font-bold mb-4">Sustainability & ESG Teams</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-6 lg:col-span-5">
              <AgentCard agent={agents[29]} />
            </div>
            <div className="md:col-span-6 lg:col-span-7">
              <AgentCard agent={agents[30]} />
            </div>
            <div className="md:col-span-6 lg:col-span-7">
              <AgentCard agent={agents[31]} />
            </div>
            <div className="md:col-span-6 lg:col-span-5">
              <AgentCard agent={agents[32]} />
            </div>
          </div> */}
          {/* <h2 className="text-4xl font-bold mb-4">Vendor Risk & Operations Teams</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-6 lg:col-span-5">
              <AgentCard agent={agents[33]} />
            </div>
            <div className="md:col-span-6 lg:col-span-7">
              <AgentCard agent={agents[34]} />
            </div>
            <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[35]} />
            </div>
          </div>
          <h2 className="text-4xl font-bold mb-4">Customer 360</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[36]} />
            </div>
          </div> */}
          <h2 className="text-4xl font-bold mb-4">Investment Agent</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[37]} />
            </div>
          </div>

          {/* <h2 className="text-4xl font-bold mb-4">Marketing Campaign Monitoring Agent</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[38]} />
            </div>
          </div> */}

          {/* <h2 className="text-4xl font-bold mb-4">MR Insights Agent</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[39]} />
            </div>
          </div> */}
          {/* <h2 className="text-4xl font-bold mb-4">Email Content Generation Agent</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
              <div className="md:col-span-6 lg:col-span-6">
                <AgentCard agent={agents[40]} />
              </div>
           
              <div className="md:col-span-6 lg:col-span-6">
                <AgentCard agent={agents[45]} />
              </div>
         
          </div> */}
          {/* 
          <h2 className="text-4xl font-bold mb-4">Qualitative Agent</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[41]} />
            </div>
            <div className="md:col-span-6 lg:col-span-6">
              <AgentCard agent={agents[42]} />
            </div>
          </div>

          <h2 className="text-4xl font-bold mb-4">Quantitative Agent</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[43]} />
            </div>
          </div> */}

          <h2 className="text-4xl font-bold mb-4">Report Anything Agent</h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-4">
            <div className="md:col-span-12 lg:col-span-12">
              <AgentCard agent={agents[44]} />
            </div>
          </div>
        </div>
      </div>
    </div>


  );
}
